import React from 'react';
import { Link } from '../LocaleLink';
import { ShieldCheck, Code2, EyeOff, WifiOff } from 'lucide-react';

interface Badge {
  icon: React.ReactNode;
  title: string;
  desc: string;
  anchor: string;
}

const BADGES: Badge[] = [
  {
    icon: <ShieldCheck size={20} className="text-violet-500" />,
    title: 'Local by default',
    desc: 'Wheel entries stay in this browser unless you share them',
    anchor: '#how-we-proved-it',
  },
  {
    icon: <Code2 size={20} className="text-violet-500" />,
    title: 'Verify in DevTools',
    desc: 'Check that analytics requests omit your wheel entries',
    anchor: '#how-we-proved-it',
  },
  {
    icon: <EyeOff size={20} className="text-violet-500" />,
    title: 'Opt-in ads only',
    desc: 'Decline consent and no ad code runs at all',
    anchor: '#how-we-proved-it',
  },
  {
    icon: <WifiOff size={20} className="text-violet-500" />,
    title: 'Works offline',
    desc: 'Disconnect internet after loading — it still spins',
    anchor: '#how-we-proved-it',
  },
];

/**
 * A row of 4 verification badges that explain local-by-default storage and
 * give visitors practical ways to inspect the behavior.
 *
 * Each badge links to the #how-we-proved-it anchor on /privacy where the
 * step-by-step DevTools walkthrough lives.
 */
const TrustBadges: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {BADGES.map(badge => (
        <Link
          key={badge.title}
          to={`/privacy${badge.anchor}`}
          className="group flex flex-col gap-2 p-4 rounded-2xl bg-violet-50 dark:bg-violet-950/30 border border-violet-100 dark:border-violet-800/40 hover:border-violet-300 dark:hover:border-violet-600 hover:shadow-sm transition-all"
        >
          <span className="flex-shrink-0">{badge.icon}</span>
          <span>
            <span className="block text-[13px] font-bold text-gray-900 dark:text-white leading-snug group-hover:text-violet-700 dark:group-hover:text-violet-300 transition-colors">
              {badge.title}
            </span>
            <span className="block text-[11px] text-gray-600 dark:text-gray-400 leading-snug mt-0.5">
              {badge.desc}
            </span>
          </span>
        </Link>
      ))}
    </div>
  </div>
);

export default TrustBadges;

